<template>
  <div>
    <UserHeader></UserHeader>
    <div class="user_change_password content-area">
      <h2>{{ $t('meta_title.security.change_password') }}</h2>

      <div class="user_form">
        <form @submit.prevent="checkForm" method="post">
          <div class="form-group">
            <label for="old_password" class="required">{{ $t('object.security.old_password') }}</label>
            <input type="password" id="old_password" name="old_password" required class="form-control"
            v-model="old_password">
          </div>

          <div class="form-group">
            <label for="user_password" class="required">{{ $t('object.security.password') }}</label>
            <input type="password" id="user_password" name="password" required class="form-control"
            v-model="password">
          </div>

          <div class="form-group">
            <label for="user_confirm_password" class="required">{{ $t('object.security.confirm_password') }}</label>
            <input type="password" id="user_confirm_password" name="confirm_password" required class="form-control"
            v-model="confirm_password">
          </div>
          <!-- <a href="" class="cart__btn btn" @click.prevent="validCart">
          </a> -->
          <button type="submit" class="change-password__btn btn">
            <span class="btn__text">Valider</span>
            <img src="/static/img/pictos/valider.svg" class="btn__picto" alt="">
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import UserHeader from "@/components/User/UserHeader";

  export default {
    name: 'SecurityChangePassword',
    data() {
      return {
        old_password: '',
        password: '',
        confirm_password: '',
      }
    },
    components: {
      UserHeader
    },
    methods: {
      checkForm: function (e) {
        if (this.password !== this.confirm_password) {
          this.$toastr.error(this.$i18n.t('error.security.mismatch_between_passwords'));
        }else{
          this.post()
        }
      },
      post(){
        this.$http.post('user/change_password', {
          old_password: this.old_password,
          password: this.password,
          confirm_password: this.confirm_password
        }, {
          redirectOnSuccess: {name: 'Profile'}
        })
      },
    }
  }
</script>


<style lang="scss" scoped>
  @import "~@/assets/scss/_colors.scss";

  .content-area{ width: 100%; margin-right: 0; padding: 0 20px; margin-top: 30px;
    h2{ font-family: 'ClanPro'; color: $color1; font-size: 20px; margin-bottom: 30px; position: relative; padding-bottom: 5px; border-bottom: 1px solid $color2; }

    label{ font-size: 12px; }

    .change-password__btn{ width: 100%; display: flex; flex-wrap: wrap; flex-direction: row; align-items: center; text-align: center; justify-content: space-between; height: 50px; color: white; background-color: $vert;  margin-top: 40px; border-radius: 0; outline: none;
      img{ width: 25px; margin-left: 5px; }
      span{ font-size: 12px; font-family: 'ClanPro'; }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Security/change_password.vue